import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useMemo, useState } from 'react';
import { formatNumber, LineChart } from '@blockanalitica/ui';
import { useChartPeriod } from '@/hooks';

export default function HistoricTabs({ address }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const yAxisConfig = {
    options: {
      scales: {
        y: {
          ticks: {
            stepSize: 1
          }
        }
      }
    }
  };
  const config = updateChartConfigWithPeriod(yAxisConfig);

  const [data, error] = useApi({
    url: `/farms/${address}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <LineChart
        key="depositors"
        data={data}
        datasets={[
          {
            xField: 'date',
            yField: 'depositors'
          }
        ]}
        timeFilter={timeFilter}
        yScaleValueFormatter={(value: number) => formatNumber(value)}
        config={config}
      />
    );
  }

  return <ChartSkeleton />;
}
